import React, { useState, useEffect } from "react";
import { ReactComponent as PlayIcon } from "../../../../assets/Icons/play2.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import 'swiper/css/pagination';
import { ReactComponent as AddListIcon } from "../../../../assets/Icons/addToWatchlist.svg";
import { ReactComponent as RemoveListIcon } from "../../../../assets/Icons/removeFromWatchlist.svg";
import { updateWatchlistData } from "../../../../network/service";
import { getMyListData } from "../../../../Redux/MyList/MyListSlice";
import Translate from "../../../../Components/Multilanguage/Translate";
import { EffectFade, Thumbs, Autoplay,Pagination } from "swiper";
import { fetchWatchlistShows } from "../../../MyList/service";

const MubiBanner = ({ data }) => {

  const dispatch = useDispatch();
  const [watchlistStatus, setWatchlistStatus] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [currentShowId, setCurrentShowId] = useState(null);
  const navigate = useNavigate();
  const windowSize = useWindowWidth();
  const user = useSelector((state) => state?.user?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  useEffect(() => {
    if (data?.shows?.length > 0) {
      const initialStatus = {};
      data.shows.forEach((item) => {
        initialStatus[item.show_id] = item.watchlist_flag;
      });
      setWatchlistStatus(initialStatus);
    }
  }, [data]);

  const fetchWatchlist = async () => {
    const response = await fetchWatchlistShows(appInfo);
    if (response?.status === 200) {
      dispatch(
        getMyListData({
          myList: response?.data?.data,
        })
      );
    }
  };

  const updateWatchlist = async (showId, flag) => {
    try {
      const response = await updateWatchlistData(appInfo, showId, flag);

      if (response?.status === 200) {
        setWatchlistStatus((prevStatus) => ({
          ...prevStatus,
          [showId]: flag,
        }));
        fetchWatchlist();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleWatchlistToggle = (showId) => {
    setCurrentShowId(showId);
    if (user) {
      const currentFlag = watchlistStatus[showId] === 1 ? 0 : 1;
      updateWatchlist(showId, currentFlag);
    } else {
      setShowNotification(true);
    }
  };

  const showClickHandler = (item) => {
    if (item?.show_id) {
      navigate(`/show-details/${item?.vanity_url ? item?.vanity_url : item?.show_id}`, {
        state: { showId: item?.show_id },
      })
    } else if (item?.event_id) {
      navigate(`/event/${item?.vanity_url ? item?.vanity_url : item?.event_id}`, {
        state: { showId: item?.event_id },
      })
    }
  }

  const handleSignIn = () => {
    navigate("/login");
    setShowNotification(false);
  };

  return (
    <div
      className={`featured2 ${template === "TEMPLATE_10" ? "gaia" : template === "TEMPLATE_9" ? 'template-9' : ""}`}
      style={{
        borderBottomColor: projectInfo?.projectConfig?.config?.BACKGROUND_COLOR || "--border-color",
      }}
    >
      <Swiper
        watchSlidesProgress
        slidesPerView={1}
        effect={"fade"}
        spaceBetween={0}
        loop={false}
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        className="mySwiper"
        modules={[EffectFade, Autoplay, Pagination]}
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="playerShowCard">
                <div className="imageContainer">
                    <img src={windowSize<640?item?.logo?item.logo:item?.banner:item?.banner || item?.logo_thumb} alt="Banner" />
                    <div className="playIconContainer" onClick={()=>showClickHandler(item)}>
                    <PlayIcon />
                    </div>
                    <div className="metaData">
                        <span className="categoryName">{item?.categories?.length>0&&item?.categories[0]?.category_name}</span>
                        <h1 className="showName">{item?.show_name}</h1>
                    {item?.director && <span className="director"><Translate textKey={'directed_by'} />  {item?.director}</span>}
                    <span className="year">{item?.year}</span>
                    <p className="description">{item?.synopsis?.slice(0,250)}{item?.synopsis?.length>250&&"..."}</p>
                    </div>
                    <div className="bottomGradient"></div>
                </div>
            </div>
            <div
              className="addToWatchList"
              onClick={() => handleWatchlistToggle(item.show_id)}
              title={watchlistStatus[item.show_id] === 1 ? <Translate textKey={'remove_from_mylist'} /> : <Translate textKey={'add_to_mylist'} />}
            >
              {watchlistStatus[item.show_id] === 1 ? <RemoveListIcon /> : <AddListIcon />}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {showNotification && 
            <div className="notification-banner">
            <div className="notification-content">
              <div className="icon-container">
                <svg className="info-icon" viewBox="0 0 286.054 286.054">
                  <path d="M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.21-52.026-116.21-116.21S78.845 26.82 143.027 26.82s116.21 52.026 116.21 116.21-52.026 116.208-116.21 116.208zm.01-196.51c-10.245 0-17.996 5.346-17.996 13.98v79.202c0 8.644 7.75 13.972 17.997 13.972 9.994 0 17.995-5.55 17.995-13.972v-79.2c0-8.43-8-13.982-17.994-13.982zm0 124.997c-9.843 0-17.853 8.01-17.853 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.003-9.85-8.003-17.86-17.845-17.86z"></path>
                </svg>
              </div>
              <div className="notification-text">
                <div className="notification-title"><Translate textKey={'sign_in_required'} /></div>
                <div className="notification-message"><Translate textKey={'sign_in_to_add'} /></div>
              </div>
              <div className="notification-actions">
                <button className="action-button primary" onClick={handleSignIn}>
                  <Translate textKey={'sign_in'} />
                </button>
                <button className="action-button secondary" onClick={() => setShowNotification(false)}>
                  <Translate textKey={'close'} />
                </button>
              </div>
            </div>
          </div>
      }
    </div>
  );
};

export default MubiBanner;
